<script async setup>
import { defineProps, computed } from "vue";
import KdIcon from "./KdIcon.vue";
import ScrollService from "../services/ScrollService.js";

const props = defineProps({
    href: {
        type: String,
        default: "#",
    },
    forceNewTab: {
        type: Boolean,
        default: false,
    },
    underline: {
        type: Boolean,
        default: true,
    },
    rel: {
        type: String,
        default: "noopener noreferrer",
    },
    type: {
        type: String,
        default: "",
    },
    variant: {
        type: String,
        default: "green", // "green", "light", "dark"
    },
    icon: {
        type: String,
        default: "",
    },
    iconClass: {
        type: String,
        default: "",
    },
    block: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});

const computedTarget = computed(() => {
    if (props.forceNewTab || (props.href.indexOf("http") === 0 && props.href.indexOf(`${window.location.hostname}/`) < 0)) {
        return "_blank";
    }

    return "_self";
});

const scrollService = new ScrollService();
const handleClick = (event) => {
    if (props.disabled) {
        event.preventDefault();
    }

    if (props.href.indexOf("#") === 0) {
        scrollService.scrollToId(props.href.replace("#", ""), event);
    } else if (props.href.indexOf("#") > 0) {
        const linkParts = props.href.split("#");
        const currentLinkParts = window.location.href.split("#");
        if (linkParts[0] === currentLinkParts[0] || linkParts[0] === window.location.pathname) {
            scrollService.scrollToId(linkParts[1], event);
        }
    }
};
</script>

<template>
    <a
        :href="props.href"
        :target="computedTarget"
        :class="{
            'opacity-50 cursor-not-allowed': props.disabled,
            'inline-block': !props.block,
            'w-full': props.block,
            'underline': props.underline && !props.icon && props.type !== 'button' && props.type !== 'download',
            'text-twg-500': props.variant === 'green',
            'text-white': props.variant === 'light',
            'text-black': props.variant === 'dark',
        }"
        :rel="props.rel"
        @click="handleClick"
    >
        <kd-icon
            v-if="props.icon"
            :icon="props.icon"
            :class="props.iconClass"
            class="inline pe-2"
            size="32"
            :fill="props.variant === 'light' ? 'white' : ''"
        />
        <span>
            <slot />
        </span>
    </a>
</template>
